import React, { useState, useEffect } from 'react';

function ProductCard(props) {

    let discontinued = props.discontinued ? 'discontinued-product' : '';

    const discontinuedCTA = this.props.discontinued
        ? <span className="full-card-discontinued-cta">Discontinued</span>
        : <React.Fragment></React.Fragment>;

    return (
        <article class={`full-card col-lg-3 ${discontinued}`}>
            <div class="full-card-media">
                <a href={props.pageUrl} tabindex="-1" class="fade-enter-done">
                    <img src={props.thumbnail} />
                </a>
            </div>
            <div class="full-card-info" style={{ padding: '15px' }}>
                <div class="full-card-subtitle-content">
                    <p class="full-card-subtitle">{props.itemNumber}  {discontinuedCTA}</p>
                </div>
                <h3 class="full-card-title" style={{marginTop: '15px'}}>
                    <a href={props.pageUrl}>{props.productName}</a>
                </h3>
                <ul class="full-card-attributes"></ul>
            </div>
        </article>

    );

}

export default ProductCard;